<!--
 * @Author: vince
 * @Date: 2021-08-18 09:23:11
 * @LastEditors: vince
 * @LastEditTime: 2021-09-07 09:18:35
 * @Description: 
-->
<template>
  <el-select
    size="small"
    v-if="controlType == 'select'"
    :value="disciplineTemp"
    :disabled="disabled"
    :multiple="multiple"
    remote
    :loading="loading"
    placeholder="请选择学科"
    :remote-method="remoteMethod"
    value-key="disciplineCode"
    :clearable="clearable"
    @change="change"
  >
    <el-option
      v-for="item in options"
      :label="item.disciplineName"
      :value="item"
      :key="item.disciplineCode"
    ></el-option>
  </el-select>
  <el-checkbox-group
    v-else-if="controlType == 'checkbox'"
    v-model="disciplineTemp"
    @change="change"
  >
    <el-checkbox :label="item" v-for="(item, index) in options" :key="index">{{
      item.disciplineName
    }}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
import { mapGetters } from "vuex";
import { postData } from "../../http/fetch.js";
export default {
  name: "displineSelector",
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      loading: false,
      options: [],
      list: [],
      disciplineTemp: [],
    };
  },
  computed: {
    ...mapGetters(["schoolCode"]),
  },
  props: {
    controlType: {
      type: String,
      default: "select",
    },
    value: {
      type: Array | Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value(v) {
      this.disciplineTemp = v;
    },
  },
  mounted() {
    this.getDisciplineFieldlList();
  },
  methods: {
    async getDisciplineFieldlList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        postData("/discipline/getDisciplinelList", {
          schoolCode: this.schoolCode,
        })
          .then((res) => {
            if (res.length) {
              res = res.map((m) => {
                return {
                  disciplineCode: m.disciplineCode,
                  disciplineName: m.disciplineName,
                };
              });
              this.list = res;
              this.options = res;
            } else {
              this.list = [];
              this.options = [];
            }

            resolve(res);
          })
          .catch((e) => {
            reject();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    async remoteMethod(query) {
      if (this.list.length == 0) {
        await this.getDisciplineFieldlList();
      }
      if (query != "") {
        this.options = this.list.filter((f) => {
          return (
            f.disciplineCode.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
            f.disciplineName.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        });
      } else {
        this.options = this.list;
      }
    },
    change(v) {
      this.disciplineTemp = v;
      this.$emit("change", v);
    },
  },
};
</script>

<style>
</style>